<template>
  <div
    v-if="getParsedStatus"
    :class="['asset-status', `asset-status--${status}`]"
    :style="{
      backgroundColor: getStatusColor
    }"
  >
    {{ getParsedStatus }}
  </div>
</template>
<script lang="ts" setup>
import { defineProps, withDefaults, computed } from 'vue';
import { ASSETS_STATUSES, ASSET_COLORS } from '@/constants/statuses';

// #interfaces
interface IProps {
  status: string;
}

// #props
const props = withDefaults(defineProps<IProps>(), {
  status: ''
});

// #computed
const getParsedStatus = computed<string>(() => {
  return ASSETS_STATUSES[props.status] || '';
});
const getStatusColor = computed<string>(() => {
  return ASSET_COLORS[props.status] || '#64748B';
});
</script>

<style scoped lang="scss">
@import '@/assets/style/_colors.scss';

.asset-status {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  border-radius: 20px;
  color: $color-ui-white;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.3px;
  width: max-content;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.18);
  }

  // Paused status with pulse animation
  &--paused {
    animation: pulse-status 2s ease-in-out infinite;
  }

  // Live auction with energetic glow
  &--liveAuction {
    box-shadow: 0 2px 10px rgba(6, 182, 212, 0.4);
  }

  // Completed with success glow
  &--completed {
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.35);
  }

  // Cancelled with subtle warning
  &--cancelled {
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
  }
}

@keyframes pulse-status {
  0%,
  100% {
    opacity: 1;
    box-shadow: 0 2px 4px rgba(217, 119, 6, 0.3);
  }
  50% {
    opacity: 0.85;
    box-shadow: 0 2px 14px rgba(217, 119, 6, 0.5);
  }
}
</style>
